import React, { useState, useEffect, useImperativeHandle, useRef, forwardRef } from 'react';
import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faXmark, faCircleCheck, faBolt, faPaperclip, faCircle, faPlus, faEllipsis, faChevronLeft, faChevronRight, faLink, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import JqxTreeGrid from 'jqwidgets-framework/jqwidgets-react-tsx/jqxtreegrid';
import 'jqwidgets-scripts/jqwidgets/jqxtreegrid';
import Trash from "../../../../assets/images/delete.svg";
import Activ from "../../../../assets/images/active.svg";
import info from "../../../../assets/images/view.png";
import Export from "../../../../assets/images/export.svg";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import Rapdf from "../../../../assets/images/pdf.png";

import Cargotruckgreen from "../../../../assets/images/cargo-truck-green.png";
import Cargotruckorange from "../../../../assets/images/cargo-truck-org.png";
import Cargotruckgrey from "../../../../assets/images/cargo-truck-gray.png";
import Cuser from "../../../../assets/images/cuser.png";

import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Docmnt from '../../../../assets/images/google-docs.png';
import { Tabs, Row, Col, Tab, Form } from 'react-bootstrap';
import Select from 'react-select';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import ActivityComments from '../../../../Components/common/ActivityComments.js';
import DownloadGrid from '../common/DownloadGrid';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { BOOKINGTRUCKDETAILS, BOOKINGTRUCKGRID, BOOKINGTRUCKMOVE, CALENDER, TRUCKERSEARCH, TRUCKORDERSDETAILS, TRUCKORDERDETAILS } from '../../../../Utils/conts.js';
import ImageUpload from '../../../../Components/common/ImageUpload.js';

import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';
import ApexCharts from 'react-apexcharts';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';


// import jsPDF from 'jspdf';


export const ExportGrid = forwardRef(({ updateGridData, onEdit }, ref) => {
  // console.log("🚀 ~ ExportActive ~ updateGridData:", updateGridData)
  // const myGridRef = useRef(null);
  // let gridElement = null;

  const [downloadOpen, setDownloadOpen] = useState(false);
  const [showSecondDiv, setShowSecondDiv] = useState(false);
  const toggleSecondDiv = () => {
    setShowSecondDiv(!showSecondDiv);
  };

  // +++++++++++++++++++ div +++++++++++++++++++++++++

  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
  };
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };


  // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload 

  const [html, setHtml] = useState('');

  function onChange(e) {
    setHtml(e.target.value);
  }

  // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,

  };

  // +++++++++++++++++++++++++++++++++++ Silk Slider


  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');

  const handleFileClick = (file) => {
    setSelectedFile(file);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedFile('');
  };

  // ++++++++++++++++++++++++++++++++++++ Zoom Image
  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [disLoading, setDisLoading] = useState(true);
  const isMountedCal = useRef(false);
  const [gridSelect, setGridSelect] = useState([]);
  const [dateData, setDateData] = useState(new Date().toISOString().split('T')[0]);
  let gridDate = ''
  const [viewDate, setViewDate] = useState(() => {
    const today = new Date();
    const day = today.getDate();
    const year = today.getFullYear();
    const month = today.toLocaleString('default', { month: 'long' });
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  });

  const gridRef = useRef(null);
  // const treeGridRef = useRef(null);
  const [filterApplied, setFilterApplied] = useState(false);
  const [gridData, setGridData] = useState({
    Active: [],
    Trash: [],
    // Trash: []

  });
  // ++++++++++++++ Status Overview.

  const [statusSeries, setStatusSeries] = useState([
    {
      name: 'Units Sold',
      data: [], // [36, 20, 16, 8,]
    },
  ]);

  const maxValue = Math.max(...statusSeries[0].data) + 10;

  const [statusOptions, setStatusOptions] = useState({
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false // This will hide the toolbar
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
        borderRadius: 4,
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        distributed: true,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      formatter: (val) => {
        return val;
      },
      style: {
        fontSize: '12px',
        colors: ["#304758"]
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: [
        ['Scheduled'],
        ['To be', 'Planned'],
        ['Planning in', 'Progress'],
        ['Planning', 'Finalized'],
      ],
    },
    yaxis: {
      title: {
        text: ' '
      },
      tickAmount: 5,
      max: maxValue,
      labels: {
        formatter: function (val) {
          return Math.floor(val); // Ensure the y-axis ticks are integers
        }
      }
    },
    fill: {
      opacity: 1,
      colors: [
        "rgba(175, 175, 175, 1)",
        "rgba(255, 85, 34, 1)",
        "rgba(255, 182, 63, 1)",
        'rgba(32, 167, 73, 1)',
      ]
    },
    legend: {
      show: false
    },
    colors: ['#d6d6d6', '#ff5522', '#ffb63f', '#20a749'], // Different colors for each bar group
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " units";
        }
      }
    }
  });

  // ++++++++++++++ Status Overview
  const fetchData = async (tab) => {
    try {
      // const dateP = dateData ? `date: ${dateData}` : ''
      const res = await withRFSToken.post(BOOKINGTRUCKGRID, { tab_name: (tab == 'Active' ? 'A' : (tab == 'Trash' ? 'T' : '')), date: dateData ? dateData : '' })
        //PK Changed As This Component Is Only Linked With BookingtruckSchedule.js
        // const res = await withRFSToken.post(BOOKINGTRUCKGRID, { tab_name: (tab == 'Active' ? 'EA' : (tab == 'Trash' ? 'ET' : '')), date: dateData ? dateData : '' })
        .then(function (res) {
          const innerData = res.data.Rows;
          const innerDataCal = res.data.chart_data;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
          const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
          // setGridData({ Active: innerData, Trash: innerData || [] });

          const counts = innerDataCal ? innerDataCal.map(item => item.count) : 0;
          const maxCount = Math.max(...counts);
          const maxValue = maxCount + 5;
          // Chart
          // setStatusOptions(prevOptions => ({
          //   ...prevOptions,
          //   xaxis: {
          //     ...prevOptions.xaxis,
          //     categories: statusLabel
          //   }
          // }));
          const colors = [
            "rgba(255, 181, 95, 1)",
            "rgba(203, 140, 255, 1)",
            "rgba(99, 169, 255, 1)",
            'rgba(84, 202, 82, 1)',
            'rgba(255, 107, 107, 1)',
          ];

          const condsData = statusData.map((value, index) => ({
            x: statusLabel[index],
            y: value,
            // fillColor: colors[index % colors.length]
          }));
          setStatusSeries([{
            name: "Trucks",
            data: condsData
          }]);
          setStatusOptions((prev) => ({
            ...prev,
            yaxis: {
              ...prev.yaxis,
              min: 0,
              max: maxValue,
              tickAmount: maxValue / 5,
            },
          }));
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    setIsLoading(false);
    setGridData({ Active: {} });
    fetchData(activeTab);
    // fetchCallanderData();
    isMounted.current = true;
  }, []);


  const [activeTab, setActiveTab] = useState('Active');

  const gridRefs = {
    Active: useRef(null),
    Trash: useRef(null),
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    if (selectedRowData) {
      setSelectedRowData(null)
    }
    setGridSelect([]);
    setIsLoading(true);
    if (tab == 'Active') {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Active: {} });
      }, 1);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setGridData({ Archived: {} });
      }, 1);
    }
    // fetchData(tab)


  };

  const [selectedRowData, setSelectedRowData] = useState(null);
  // new data for dynamic
  // const [gridData, setGridData] = useState([]);

  useEffect(() => {
    if (updateGridData) {
      // setGridData(updateGridData.active);
      const grid = window.$(gridRefs[activeTab]?.current);
      grid?.jqxGrid('updatebounddata');
      grid?.jqxGrid('refresh');
      const now = new Date();
      const startOfPreviousMonth = getStartOfPreviousMonth(now);
      const endOfNextMonth = getEndOfNextMonth(now);
      fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
      fetchData(activeTab);
      if (selectedRowData) {
        loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id);
      }
    }
    else {
      console.log('No Data');
    }
  }, [updateGridData]);

  const getChartData = (innerDataCal) => {
    const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
    const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
    // setGridData({ Active: innerData, Trash: innerData || [] });

    const counts = innerDataCal ? innerDataCal.map(item => item.count) : 0;
    const maxCount = Math.max(...counts);
    const maxValue = maxCount + 5;
    const countDiff = maxCount / 5;
    // console.log('maxValue', maxValue);
    // console.log('maxCount', maxCount);


    const colors = [
      "rgba(255, 181, 95, 1)",
      "rgba(203, 140, 255, 1)",
      "rgba(99, 169, 255, 1)",
      'rgba(84, 202, 82, 1)',
      'rgba(255, 107, 107, 1)',
    ];

    const valueMap = Object.fromEntries(statusData.map((y, i) => [statusLabel[i], y]));

    const categories = [
      'Scheduled',
      'To be Planned',
      'Planning in Progress',
      'Planning Finalized'
    ];

    // Build aligned data (O(1) lookups)
    const alignedData = categories.map(cat => valueMap[cat] ?? 0);

    setStatusOptions((prev) => ({
      ...prev,
      yaxis: {
        ...prev.yaxis,
        min: 0,
        max: maxCount > 0 ? maxValue : 5,
        tickAmount: maxCount > 5 ? maxValue / countDiff : 5,
      },
    }));
    setStatusSeries([{
      name: "Trucks",
      data: alignedData
    }]);

    setTimeout(() => {
      setDisLoading(false)
    }, 1000);
  }

  // console.log("NNN", gridData);
  let checkUlds = [];
  let filterForCheck = false;

  useEffect(() => {
    if (gridRefs[activeTab]?.current) {
      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      let tabType = '';
      if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'T' }

      const parentDiv = gridRefs[activeTab].current.parentElement;
      const parentHeight = parentDiv?.offsetHeight || 700;
      const rowHeight = Math.floor(parentHeight / 50);

      const source = {
        datatype: 'json',
        datafields: [
          // { name: 'selected', type: 'bool' },
          { name: 'bookingtruck_no', type: 'string' },
          { name: 'bookingtruck_id', type: 'string' },
          { name: 'bookingtruck_date_id', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'RStatus', type: 'string' },
          { name: 'departure_date', type: 'string' },
          { name: 'departure_time', type: 'string' },
          { name: 'board_point', type: 'string' },
          { name: 'off_point', type: 'string' },
          { name: 'arrival_date', type: 'string' },
          { name: 'travel_time', type: 'string' },
          { name: 'arrival_time', type: 'string' },
          { name: 'shipment_type', type: 'string' },
          { name: 'volume', type: 'string' },
          { name: 'region', type: 'string' },
          { name: 'change', type: 'string' },
          { name: 'truck_status', type: 'string' },
        ],
        // localdata: gridData[activeTab],
        id: `${activeTab}-`,
        url: `${process.env.REACT_APP_RFS_URL}booking-truck?tab_name=${tabType}&date=${dateData}`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 50,
        filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRefs[activeTab]?.current).jqxGrid('clearselection');
          window.$(gridRefs[activeTab]?.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          getChartData(data.chart_data)
        },
        sort: function () {
          window.$(gridRefs[activeTab]?.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + info + '" class="row_info" /></div>';
          },

          width: '5%', filterable: false,
        },
        { text: 'Bookingtruck', filtertype: 'textbox', datafield: 'bookingtruck_no', width: '10%', cellclassname: 'firstcl', },
        {
          text: 'Planning Status',
          filtertype: 'checkedlist',
          filteritems: [
            { label: 'Scheduled', value: 's' },
            { label: 'To be Planned', value: 't' },
            { label: 'Planning in Progress', value: 'p' },
            { label: 'Planning Finalized', value: 'f' },

          ],
          datafield: 'status',
          width: '15%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            // Check the value of the 'Status' field
            // console.log('12', rowdata);

            if (rowdata.status === 'Scheduled') {
              // Return HTML with class 'inactive' for 'i' status
              return '<div class="jqx-grid-cell-left-align bookingstatus scheduled"> Scheduled </div>';
            } else if (rowdata.status === 'To be Planned') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus tbplanned">To be Planned</div>';
            }
            else if (rowdata.status === 'Planning in Progress') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pprogress">Planning in Progress</div>';
            }
            else if (rowdata.status === 'Planning Finalized') {
              // Return HTML with class 'active' for 'a' status
              return '<div class="jqx-grid-cell-left-align bookingstatus pfinalized">Planning Finalized</div>';
            }
            else {
              // Return default HTML
              return defaulthtml;
            }
          }
        },
        {
          text: 'Truck Status', filtertype: 'textbox', datafield: 'truck_status', width: '10%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            if (rowdata.truck_status === 'Grey') {
              return '<div class="grid_actions"><img src="' + Cargotruckgrey + '" class="row_info" /></div>';
            } else if (rowdata.truck_status === 'Orange') {
              return '<div class="grid_actions"><img src="' + Cargotruckorange + '" class="row_info" /></div>';
            } else if (rowdata.truck_status === 'Green') {
              return '<div class="grid_actions"><img src="' + Cargotruckgreen + '" class="row_info" /></div>';
            }
          }
        },
        { text: 'Boardpoint', filtertype: 'textbox', datafield: 'board_point', width: '7%' },
        { text: 'Offpoint', filtertype: 'textbox', datafield: 'off_point', width: '6%' },
        { text: 'Dep Time', filtertype: 'textbox', datafield: 'departure_time', width: '8%' },
        // { text: 'Arrival Date', filtertype: 'textbox', datafield: 'arrival_date', width: '12%' },
        { text: 'Arr Time', filtertype: 'textbox', datafield: 'arrival_time', width: '8%' },


        // { text: 'Departure Date', filtertype: 'textbox', datafield: 'departure_date', width: '10%' },


        { text: 'Region', filtertype: 'textbox', datafield: 'region', width: '10%' },
        // { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '15%' },
        {
          text: 'Volume',
          datafield: 'volume',
          width: '15%',
          filtertype: 'textbox',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            const changeValue = rowdata.change || '';

            // Determine background color
            let bgColorClass = '';
            if (changeValue.startsWith('+')) {
              bgColorClass = 'bg-success text-light py-1 px-2 rounded';
            } else if (changeValue.startsWith('-')) {
              bgColorClass = 'bg-danger text-light py-1 px-2 rounded';
            }
            return `<div class="jqx-grid-cell-left-align" style="line-height: 49px;">
              ${value} <span class="${bgColorClass}">${changeValue}</span>
            </div>`;
          },
        },
        {
          text: 'Type',
          datafield: 'shipment_type',
          width: '8%',
          filtertype: 'checkedlist',
          filteritems: [
            { label: 'Import', value: 'Import' },
            { label: 'Export', value: 'Export' },
          ],

          // cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
          //   if (value === 'I') {
          //     return '<div class="jqx-grid-cell-left-align mt-3">Import</div>';
          //   } else if (value === 'E') {
          //     return '<div class="jqx-grid-cell-left-align mt-3">Export</div>';
          //   }
          //   return defaulthtml;
          // }
        },
      ];
      const nestedColumns = [
        {
          text: 'Actions',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            return '<div class="grid_actions"><img src="' + info + '" class="nested_row_info" /></div>';
          },

          width: '5%', filterable: false,
        },
        { text: 'Truck No.', datafield: 'truck_no', width: '10%' },
        {
          text: 'Order Status',
          datafield: 'planning_status',
          width: '12%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            if (value === 'D') return '<div class="jqx-grid-cell-left-align order_status_draft" style="margin-top:15px;">Draft</div>';
            if (value === 'R') return '<div class="jqx-grid-cell-left-align order_status_requested" style="margin-top:15px;">Requested</div>';
            if (value === 'O') return '<div class="jqx-grid-cell-left-align order_status_offer_received" style="margin-top:15px;">Offer Received</div>';
            if (value === 'B') return '<div class="jqx-grid-cell-left-align order_status_booked" style="margin-top:15px;">Booked</div>';
            return '<div class="jqx-grid-cell-left-align" style="margin-top:15px;">' + (value || '') + '</div>';
          }
        },
        {
          text: 'PDF-File', datafield: 'pdf', width: '8%',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue) { //  + process.env.REACT_APP_BASE_URL_IMAGE + 'TruckMonitor/'
              defaultHtml = "<div style='text-align: left;line-height: 38px;'><a target='_blank' href=' " + cellValue + " '>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
            }
            return (
              defaultHtml
            );
          },
        },
        { text: 'Departure Date', datafield: 'departure_date', width: '12%' },
        { text: 'Departure Time', datafield: 'departure_time', width: '12%' },
        { text: 'Arrival Date', datafield: 'arrival_date', width: '10%' },
        { text: 'Arrival Time', datafield: 'arrival_time', width: '10%' },
        {
          text: 'Truckload',
          datafield: 'truck_load_type',
          width: '14%',
          cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
            if (value === 'F') return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">FTL</div>';
            if (value === 'L') return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">LTL</div>';
            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + (value || '') + '</div>';
          }
        },
      ];
      const nestedGrids = {};
      const initrowdetails = (index, parentElement, gridElement, record) => {
        const nestedGridContainer = parentElement.children[0];
        const parentRowId = record.uid.toString();
        nestedGrids[parentRowId] = nestedGridContainer;
        parentElement.addEventListener('click', (event) => {
          const target = event.target;
          if (window.$(target).hasClass('jqx-icon-arrow-right')) {
            event.stopPropagation();
          }
        });
        const id = record.uid.toString();
        const uldGrid = Array.isArray(record.package_information)
          ? record.package_information
          : (record.package_information ? [record.package_information] : []);

        const subendPoint = `get-linked-truck-orders?bookingtruck_date_id=${record.bookingtruck_date_id}`;

        const nestedSource = {
          datatype: "json",
          id: "shipmentChildID",
          datafields: [
            { name: "arrival_date", type: "string" },
            { name: "arrival_time", type: "string" },
            { name: "departure_date", type: "string" },
            { name: "departure_time", type: "string" },
            { name: "id", type: "string" },
            { name: "pdf", type: "string" },
            { name: "planning_status", type: "string" },
            { name: "truck_load_type", type: "string" },
            { name: "truck_no", type: "string" },
            { name: "pivot", type: "string" },
          ],
          // localdata: uldGrid,
          url: `${process.env.REACT_APP_RFS_URL}${subendPoint}`,
          // beforeSend: function (jqXHR) {
          //   jqXHR.setRequestHeader("Authorization", token);
          // },
          // localdata: gridData[activeTab],
          pagesize: 50,
          filter: function (allfilters) {
            if (allfilters.length > 0) {
              setFilterApplied(true);
              filterForCheck = true;
            } else {
              setFilterApplied(false);
              filterForCheck = false;
            }
            window.$(gridRefs[activeTab].current).jqxGrid("clearselection");
            window
              .$(gridRefs[activeTab].current)
              .jqxGrid("updatebounddata", "filter");
          },
          beforeprocessing: function (data) {
            source.totalrecords = data.TotalRows;
          },
          sort: function () {
            window
              .$(gridRefs[activeTab].current)
              .jqxGrid("updatebounddata", "sort");
          },
          root: "Rows",
          cache: false,
        };
        const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
        const nestedGridOptions = {
          width: '90%',
          pageable: false,
          sortable: false,
          autoheight: true,
          height: (10 * 45),
          selectionmode: 'none',
          source: nestedDataAdapter,
          filterable: false,
          columns: nestedColumns,
          rowdetails: true,
          rowsheight: 45,
          showemptyrow: false,
          ready: function () {
            const rows = window.$(nestedGridContainer).jqxGrid('getrows');
            for (let i = 0; i < rows.length; i++) {
              const rowid = i;
              const row = rows[i];
              window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
              window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
              window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
            }
          },
        };
        window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

        window.$(nestedGridContainer).off("click").on("click", ".nested_row_info", function () {
          const rowDiv = window.$(this).closest('[role="row"]');
          const rowIndex = window.$(rowDiv).attr('row-id');
          const rowData = window.$(nestedGridContainer).jqxGrid('getrowdata', rowIndex);
          console.log('rowData:', rowData);

          if (rowData) {
            // const parentRow = record;
            // console.log('record',parentRow);
            const sendData = { truck_orders_id: rowData?.pivot?.truck_order_id, tab: 'shipment', back: '/BookingtruckSchedule' }
            localStorage.setItem('TODetails', JSON.stringify(sendData));
            window.location.href = '/TruckOrderDetails';
          } else {
            console.error('No data found for the given row index.');
          }
        });
      };
      const gridOptions = {
        width: '100%',
        height: parentHeight,
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        selectionmode: 'checkbox',
        pageable: true,
        pageSize: 50,
        pagesizeoptions: ['50', '100', '200', '500'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        initrowdetails: initrowdetails,
        rowdetails: true,
        rowdetailstemplate: {
          rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
          rowdetailsheight: (5 * 45),
          rowdetailshidden: true,
        },
        rendergridrows: function (params) {
          return params.data;
        },
      };


      window.$(gridRefs[activeTab]?.current).jqxGrid(gridOptions);
      window.$(gridRefs[activeTab]?.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRefs[activeTab].current).off('cellclick');
      window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 2) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          loadDetails(args.bookingtruck_id, args.bookingtruck_date_id);
        }
      });
      // window.$(gridRefs[activeTab]?.current).off('rowclick');
      // window.$(gridRefs[activeTab]?.current).on('rowclick', async (event) => {
      //   // console.log('event', event.args.row.bounddata);
      //   const args = event.args.row.bounddata;
      //   const clickedRowIndex = event.args.rowindex;

      //   console.log('args', args);
      //   // const rowData = dataAdapter.records[args.index];
      //   // console.log('rowdata', rowData);
      //   loadDetails(args.bookingtruck_id, args.bookingtruck_date_id);

      //   window.$(gridRefs[activeTab]?.current).find('[role="row"]').removeClass('custom-active-row');;
      //   window.$(gridRefs[activeTab]?.current).find(`[role="row"][row-id='${clickedRowIndex}']`).addClass('custom-active-row');
      //   // rows.addClass('custom-active-row');
      //   // window.$(gridRefs[activeTab]?.current).jqxGrid('autoresizecolumns');
      // });
      window.$(gridRefs[activeTab]?.current).on('click', '.row_info', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRefs[activeTab]?.current).jqxGrid('getrowdata', rowIndex);
        // setDeleteId(rowData.id);
        // setConfModal(true);
        console.log("rowData", rowData);
        loadDetails(rowData.bookingtruck_id, rowData.bookingtruck_date_id, "DR");
        //window.location.href = '/BookingtruckDetails'
      });
      // window.$(gridRefs[activeTab]?.current).on('click', '.nested_row_info', function () {
      //   const rowDiv = window.$(this).closest('[role="row"]');
      //   const rowIndex = window.$(rowDiv).attr('row-id');
      //   const rowData = window.$(gridRefs[activeTab]?.current).jqxGrid('getrowdata', rowIndex);

      //   // setDeleteId(rowData.id);
      //   // setConfModal(true);
      //   console.log("rowData", rowData);
      //   loadDetails(rowData.bookingtruck_id, rowData.bookingtruck_date_id, "DR");
      //   //window.location.href = '/BookingtruckDetails'
      // });

    }

  }, [gridData]);

  // row selection by checkbox
  window.$(gridRefs[activeTab]?.current).on('rowselect', (event) => {
    if (event.args.row) {
      const selectedRow = event.args.row;
      const uldNumber = selectedRow.bookingtruck_id;
      const selectedRowId = selectedRow.uid;
      if (!checkUlds.includes(uldNumber)) {
        checkUlds.push(uldNumber);
      }
      // console.log(checkUlds);
      // if (!gridSelect.some(row => row.bookingtruck_id === uldNumber)) {
      //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
      // }
      setGridSelect(prevGridSelect => {
        if (!prevGridSelect.some(row => row.bookingtruck_id === uldNumber)) {
          return [...prevGridSelect, selectedRow];
        }
        return prevGridSelect;
      });
    } else {
      if (event.args.rowindex.length > 0) {
        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
        setGridSelect(allIds);
      } else {
        setGridSelect([]);
      }
    }
    // console.log("🚀 ~ window.$ ~ event:00000000", event.args.row)
    // const bookTruckid = event.args.row.bookingtruck_id;
    // const selectedRow = event.args.row;
    // if (event.args.row) {

    //   setGridSelect(prevGridSelect => {
    //     if (!prevGridSelect.some(row => row.bookingtruck_id === bookTruckid)) {
    //       return [...prevGridSelect, selectedRow];
    //     }
    //     return prevGridSelect;
    //   });
    //   // setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
    // } else {
    //   if (event.args.rowindex.length > 0) {
    //     const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
    //     setGridSelect(allIds);
    //   } else {
    //     setGridSelect([]);
    //   }
    // }
  });

  window.$(gridRefs[activeTab]?.current).on('rowunselect', (event) => {
    if (event.args.row) {
      const unselectedRowId = event.args.row.bookingtruck_id;
      setGridSelect(prevSelection => prevSelection.filter(row => row.bookingtruck_id !== unselectedRowId));
      // if(filterForCheck!=true){

      // if (!checkUlds.includes(unselectedRowId)) {
      //   checkUlds.push(unselectedRowId);
      // } else {
      //   checkUlds = checkUlds.filter(item => item !== unselectedRowId);
      // }

      //   const unselectedRowId = event.args.row.bookingtruck_id;
      //   setGridSelect(prevSelection => prevSelection.filter(id => id.bookingtruck_id !== unselectedRowId));
      // } else {
      //   setGridSelect([]);
      // }
    }
  });
  // End row selection 

  const [dataToSend, setDataToSend] = useState({});
  const loadDetails = async (number, dateid, type = null) => {
    try {
      const res = await withRFSToken.post(BOOKINGTRUCKDETAILS, { bookingtruck_id: number, bookingtruck_date_id: dateid, })
        .then(function (res) {
          if (res.data.response_code == 200) {
            const innerData = res.data.response_data;

            localStorage.removeItem('BTDetails');
            const updateData = {
              ...innerData,
              arrival_date_time: innerData.arrival_date + 'T' + innerData.arrival_time,
              departure_date_time: innerData.departure_date + 'T' + innerData.departure_time
            }
            localStorage.setItem('BTDetails', JSON.stringify(updateData));
            if (type == "DR") {
              window.location.href = '/BookingtruckDetails'
            } else {
              setSelectedRowData(innerData);
              setDataToSend({ bookingtruck_id: innerData?.bookingtruck_id, bookingtruck_date_id: innerData?.bookingtruck_date_id, date: innerData?.date })
            }
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  }

  useImperativeHandle(ref, () => ({
    handleCloseClick,
  }));

  const handleCloseClick = () => {
    setSelectedRowData(null);
  };
  const handleDeleteButtonClick = () => {
    deleteSelectedRows(gridSelect);
    // if (gridSelect){
    //   handleShowConfirmation(deleteSelectedRows);
    // }
  };
  const deleteSelectedRows = async (selectedIds) => {
    // Perform deletion logic here using the selected IDs
    // console.log("Archive selected IDs:", selectedIds);
    const ids = selectedIds.map(id => id.bookingtruck_date_id)
    // console.log("🚀 ~ deleteSelectedRows ~ ids:", ids)
    const uniqueIds = Array.from(new Set(ids));
    // Now you can send the selected IDs to your API or perform any other action
    if (selectedIds.length > 0) {
      try {
        const response = await withRFSToken.post(BOOKINGTRUCKMOVE, { bookingtruck_nos: uniqueIds, action: activeTab === 'Active' ? 'D' : 'A' });
        if (response.data.response_code === 200) {
          fetchData(activeTab);

          const now = new Date();
          const startOfPreviousMonth = getStartOfPreviousMonth(now);
          const endOfNextMonth = getEndOfNextMonth(now);
          fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
        }
        // reloadGrid();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    window.$(gridRefs[activeTab]?.current).jqxGrid('unselectrow', selectedIds);
    window.$(gridRefs[activeTab]?.current).jqxGrid('clearselection');
    // dispatch(fetchStationGridData());
    // reloadGrid();
  };
  // const reloadGrid = async () => {
  //   try {
  //       const res = await axios.post(process.env.REACT_APP_BASE_URL + DASHBOARD, {}, {
  //           headers: {
  //               'Authorization': `Bearer ${localStorage.getItem('token')}`,
  //               'Content-Type': 'application/json'
  //           }
  //       });
  //       const innerData = res.data.data;
  //       setPlanData(innerData);
  //   } catch (error) {
  //       console.error('Error reloading data:', error);
  //   }
  // };

  const showDownloadModal = () => {
    setDownloadOpen(true);
  };
  const closeDownloadModal = () => {
    setDownloadOpen(false);
  };

  const exportToExcel = () => {
    if (gridRefs[activeTab]?.current) {
      window.$(gridRefs[activeTab]?.current).jqxGrid('exportdata', 'xls', 'GridData');
    }
  };
  const exportToPDF = () => {
    if (gridRefs[activeTab]?.current) {
      window.$(gridRefs[activeTab]?.current).jqxGrid('exportdata', 'pdf', 'GridData');
    }
  };

  const handleEditClick = () => {
    // Extract the 10 fields you need from selectedRowData
    const dataToSend = {
      booking_type: 'E',
      bookingtruck_no: selectedRowData.bookingtruck_no,
      boardpoint: selectedRowData.boardpoint,
      boardpoint_address: selectedRowData.boardpoint_address,
      offpoint: selectedRowData.offpoint,
      offpoint_address: selectedRowData.offpoint_address,
      trip_type: selectedRowData.trip_type,
      date: selectedRowData.data,
      time: selectedRowData.trip_type,
      selected_days: selectedRowData.selected_days,
      freq_date: selectedRowData.freq_date,
      freq_time: selectedRowData.freq_time,
      start_date: selectedRowData.start_date,
      end_date: selectedRowData.end_date,
      departure_date: selectedRowData.departure_date,
      departure_time: selectedRowData.departure_time,
      arrival_time: selectedRowData.arrival_time
    };

    // Call the parent's edit function
    const datas = { ...selectedRowData, add_edit: 'E' };
    onEdit(datas);
  };
  // ++++++++++++++ Calender 

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const handleDayClick = async (date, event) => {
    setDisLoading(true)
    setSelectedDate(date);
    const year = date.getFullYear();
    let month = (`0${date.getMonth() + 1}`).slice(-2); // Ensure month is 2 digits
    const day = (`0${date.getDate()}`).slice(-2); // Ensure day is 2 digits

    const formattedDate = `${year}-${month}-${day}`;
    setDateData(formattedDate);
    gridDate = formattedDate;


    month = date.toLocaleString('default', { month: 'long' });
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    setViewDate(`${day}${getOrdinal(day)} ${month} ${year}`);

    const source = window.$(gridRefs[activeTab].current).jqxGrid('source');
    if (source) {
      source._source.url = `${process.env.REACT_APP_RFS_URL}booking-truck?tab_name=${activeTab === 'Active' ? 'A' : 'T'}&date=${formattedDate}`;
      window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
    }
    setTimeout(() => {
      setDisLoading(false)
    }, 1000);
    // setTimeout(() => {
    //   setIsLoading(false);
    //   window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
    // }, 1);
    // try {
    //   const res = await withRFSToken.post(BOOKINGTRUCKGRID, { tab_name: (activeTab == 'Active' ? 'A' : (activeTab == 'Trash' ? 'T' : '')), date: formattedDate })
    //     .then(function (res) {
    //       const innerData = res.data.Rows;
    //       console.log("🚀 ~ .then ~ innerData:", innerData)
    //       setGridData({ Active: innerData, Trash: innerData });

    //       const innerDataCal = res.data.chart_data;
    //       const statusLabel = innerDataCal ? innerDataCal.map((item) => item.planning_status) : [];
    //       const statusData = innerDataCal ? innerDataCal.map((item) => item.count) : [];
    //       const counts = innerDataCal ? innerDataCal.map(item => item.count) : 0;
    //       const maxCount = Math.max(...counts);
    //       const maxValue = maxCount + 5;
    //       // Chart
    //       // setStatusOptions(prevOptions => ({
    //       //   ...prevOptions,
    //       //   xaxis: {
    //       //     ...prevOptions.xaxis,
    //       //     categories: statusLabel
    //       //   }
    //       // }));
    //       const colors = [
    //         "rgba(255, 181, 95, 1)",
    //         "rgba(203, 140, 255, 1)",
    //         "rgba(99, 169, 255, 1)",
    //         'rgba(84, 202, 82, 1)',
    //         'rgba(255, 107, 107, 1)',
    //       ];

    //       const condsData = statusData.map((value, index) => ({
    //         x: statusLabel[index],
    //         y: value,
    //         // fillColor: colors[index % colors.length]
    //       }));

    //       setStatusOptions((prev) => ({
    //         ...prev,
    //         yaxis: {
    //           ...prev.yaxis,
    //           tickAmount: maxValue,
    //         },
    //       }));
    //     });

    // } catch (error) {
    //   console.error('Error fetching data:', error);
    // }
    // fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
    // setSelectedDate(date);  // Store the selected date
    // if (childRef.current) {
    //   childRef.current.handleCloseClick();
    // }
  };
  const [borderDates, setBorderDates] = useState([]);
  // const borderDates = [
  //   { date: new Date(2024, 8, 15), colors: ['#D6D6D6'] },
  //   { date: new Date(2024, 8, 20), colors: ['#FF5522'] },
  //   { date: new Date(2024, 8, 25), colors: ['#FFB63F'] },
  //   { date: new Date(2024, 8, 22), colors: ['#20A749'] },
  // ];



  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [lastDayOfMonth, setLastDayOfMonth] = useState(null);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
    const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    return `${year}-${month}-${day}`;
  };

  const getStartOfPreviousMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  };

  const getEndOfNextMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 2, 0); // 0th day gives last day of the next month
  };

  const getLastDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0); // 0th day of the next month gives last day of the current month
  };

  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const startOfPreviousMonth = getStartOfPreviousMonth(activeStartDate);
    const endOfNextMonth = getEndOfNextMonth(activeStartDate);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));
  };

  const handleMonthClick = (date) => {
    setActiveStartDate(date);
    const lastDay = getLastDayOfMonth(date);
    setLastDayOfMonth(formatDate(lastDay));
    console.log("Last day of the clicked month:", formatDate(lastDay));

    const startOfPreviousMonth = getStartOfPreviousMonth(date);
    const endOfNextMonth = getEndOfNextMonth(date);
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
  };

  const statusToColorMap = {
    s: '#D6D6D6',
    t: '#FF5522',
    p: '#FFB63F',
    f: '#20A749'
  };


  useEffect(() => {
    const now = new Date();
    const startOfPreviousMonth = getStartOfPreviousMonth(now);
    const endOfNextMonth = getEndOfNextMonth(now);

    setStartDate(formatDate(startOfPreviousMonth));
    setEndDate(formatDate(endOfNextMonth));

    // isMounted.current = false;
    if (isMountedCal.current) return;
    fetchCallanderData(formatDate(startOfPreviousMonth), formatDate(endOfNextMonth));
    isMountedCal.current = true;
  }, []);

  const fetchCallanderData = async (sd, ed) => {
    try {
      // const dateP = dateData ? `date: ${dateData}` : ''
      const res = await withRFSToken.post(CALENDER, { tab_name: (activeTab == 'Active' ? 'A' : (activeTab == 'Trash' ? 'T' : '')), start_date: sd, end_date: ed })
        .then(function (res) {
          const innerData = res.data.response_data;
          // console.log("🚀 ~ .then ~ innerData:", innerData)
          const transformedDates = innerData.map(item => ({
            date: new Date(item.booking_date), // Convert booking_date to Date object
            colors: [statusToColorMap[item.planning_status]] // Get the corresponding color
          }));

          setBorderDates(transformedDates);

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const dateEntry = borderDates.find(d => d.date.toDateString() === date.toDateString());
      const colors = dateEntry?.colors || [];

      return (
        <div className="multi-border" style={{ height: '100%' }}>
          {colors.map((color, index) => (
            <div
              key={index}
              className="border-stripe"
              style={{ borderBottom: `3px solid ${color}` }}

            />
          ))}
        </div>
      );
    }
    return null;
  };

  const getDeialsClick = (e) => {
    if (e == 'P') {
      window.location.href = '/BookingtruckDetails/Planning'
    } else {
      window.location.href = '/BookingtruckDetails'
    }
  }
  const handleOrderTruck = () => {
    localStorage.removeItem('OT');
    const sendData = {
      truck_type: 'B',
      bookingTruck_type: 'E',
      existing_date: selectedRowData.date
    }
    localStorage.setItem('OT', JSON.stringify(sendData));
    window.location.href = '/OrderTruck'
  }

  const getToDeialsClick = (id, e) => {
    localStorage.removeItem('TODetails');
    const storageData = { truck_orders_id: id, tab: e };
    localStorage.setItem('TODetails', JSON.stringify(storageData));
    window.location.href = '/TruckOrderDetails'
  }

  const resetFilters = () => {
    window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
  };

  const handleOrderTruckOrder = async (info) => {
    // console.log('info', info);
    localStorage.removeItem('OT');
    try {
      const res = await withRFSToken.post(TRUCKORDERDETAILS, { truck_orders_id: info.truck_orders_id })
        .then(function (res) {
          if (res.data.response_code == 200) {
            const innerData = res.data.response_data;
            console.log('innerData', innerData);
            const sendData = {
              ...innerData,
              truck_type: 'B',
              departure_date_time: innerData.departure_date + 'T' + innerData.departure_time,
              arrival_date_time: innerData.arrival_date + 'T' + innerData.arrival_time,
              // bookingTruck_type: 'E',
              // bookingTruck_type: selectedRowData.bookingTruck_type,
              existing_date: selectedRowData.date,
              step: 1
            }
            // console.log('sendData', sendData);

            localStorage.setItem('OT', JSON.stringify(sendData));
            window.location.href = '/OrderTruck'
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  };


  return (
    <>
      {/* {console.log('sadd', gridSelect)} */}
      {downloadOpen && <DownloadGrid download_area='bt' download_sec={activeTab == 'Active' ? 'A' : 'T'} onClose={closeDownloadModal} />}
      <div className='exp-btn'>

        <button onClick={handleDeleteButtonClick}> <img src={activeTab === 'Active' ? Trash : Activ} alt="icon" /> Move to {activeTab === 'Active' ? 'Trash' : 'Active'}</button>
        <button onClick={showDownloadModal}><img src={Export} /> Download</button>
      </div>
      <div className="maindiv">
        <div className='trashdonload rfs_grid'>
          <Tabs defaultActiveKey={activeTab} id="nested" className="booking_tab" onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''}>
            <Tab eventKey="Active" className='moveto ' title={<span>Active</span>}>
              {/* {!isLoading && <div ref={gridRefs.Active} className='bookinggrid'></div>} */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Active} className='bookinggrid' ></div>
              </>
              }
            </Tab>
            <Tab eventKey="Trash" className='moveto ' title={<span>Trash</span>}>
              {/* {!isLoading && <div ref={gridRefs.Trash} className='bookinggrid'></div>} */}
              {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRefs.Trash} className='bookinggrid' ></div>
              </>
              }
            </Tab>
          </Tabs>
        </div>
        <div className='rfsRight mt-45'>
          {!selectedRowData && (
            <>
              <div className='rfs_time text-center'>{viewDate}</div>
              <div className='calender_rfs mb-3 p-0'>
                <div>
                  <Calendar
                    value={selectedDate}
                    activeStartDate={activeStartDate}
                    tileClassName={({ date, view }) =>
                      view === 'month' && date.toDateString() === new Date().toDateString() ? 'selected-tile' : ''
                    }
                    tileContent={tileContent}
                    onClickDay={(date, event) => handleDayClick(date, event)}
                    // onClick={(event) => handleDayClick(date, event)}
                    // onActiveStartDateChange={handleActiveStartDateChange}

                    // onClickMonth={handleMonthClick}
                    onActiveStartDateChange={({ activeStartDate, view }) => {
                      // handleActiveStartDateChange();
                      if (view === 'month') {
                        handleMonthClick(activeStartDate);
                      }
                    }}
                  />
                </div>
              </div>

              <div className='calender_rfs position-relative'>
                <div className="new_chart">
                  <h3>Status Overview</h3>
                  <p>Overview of Current Booking Truck Statuses</p>
                </div>
                {disLoading &&
                  <div className='mvt loader-container' style={{ top: '60px', height: '80%', background: '#fff', position: 'absolute' }}>
                    <span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '11vh' }}></span>
                  </div>
                }
                <ApexCharts
                  options={statusOptions}
                  series={statusSeries}
                  type="bar"
                  height={'88%'}
                />
              </div>
            </>

          )}
          {/* Display the selected row data */}
          {selectedRowData && (
            <div className='SecondDiv rfs_width'>
              {/* {console.log('555', selectedRowData)} */}
              <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
              <div className='girddtals_header'>
                <h3>
                  {selectedRowData.bookingtruck_no}
                  <span className={
                    selectedRowData.status === 'Scheduled' ? 'bookingstatus scheduled mx-2 abslt'
                      : (selectedRowData.status === 'To be Planned' ? 'bookingstatus tbplanned mx-2 abslt'
                        : (selectedRowData.status === 'Planning in Progress') ? 'bookingstatus pprogress mx-2 abslt'
                          : ((selectedRowData.status === 'Planning Finalized' ? 'bookingstatus pfinalized mx-2 abslt'
                            : 'bookingstatus')))
                  }>
                    {selectedRowData.status}
                  </span>
                </h3>
                <div className='d-flex actbtn justify-content-between'>
                  <div className='d-flex'>
                    <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                    {/* <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <FontAwesomeIcon icon={faBolt} /> Action
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={handleEditClick}>Edit Bookingtruck</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={() => getDeialsClick('P')}>Planning</Dropdown.Item>
                        <Dropdown.Item href="#" onClick={handleOrderTruck}>Order Truck</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}
                  </div>
                  <div className='viwall'>
                    <Link to='#' onClick={() => getDeialsClick('D')}>View Details</Link>
                  </div>
                </div>
              </div>
              <div className='d-flex justify-content-between rabord'>
                <div className='firstbrd'>
                  <p>Boardpoint</p>
                  <span>{selectedRowData?.boardpoint}</span>
                </div>
                <div className='middlebrd'>
                  <p><span style={{ fontSize: '14px' }}><b>DEP : </b>{selectedRowData?.departure_date} {selectedRowData?.departure_time}</span></p>
                  <p><img src={Cargotruck} /></p>
                  <p><span style={{ fontSize: '14px' }}><b>ARR : </b>{selectedRowData?.arrival_date} {selectedRowData?.arrival_time}</span></p>
                </div>
                <div className='lastbrd'>
                  <p>Offpoint</p>
                  <span>{selectedRowData?.offpoint}</span>
                </div>
              </div>
              <div>
                <h3>Operational Trucks</h3>
                {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                  <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                    {/* {console.log("🚀 ~ ExportActive ~ truck:", truck)} */}
                    <div>
                      <span>Truck No</span>
                      <h4>{truck.truck_no}</h4>
                    </div>
                    {/* <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                      <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                    </div> */}
                    <div className={truck.status == 'Offer Received' ? 'offer_reecv' : (truck.status == 'Booked' ? 'booked' : 'offer_rqst')}>
                      <span>{truck.status}</span>
                    </div>
                    <div>
                      {/* <Link to='#' onClick={() => getToDeialsClick(truck.truck_orders_id, 'shipment')}>Details</Link> */}
                      {truck.status === 'Draft' ? (
                        truck.status === 'Draft' && (
                          <Link to='#' onClick={() => handleOrderTruckOrder(truck)}>Order</Link>
                        )
                      ) : (
                        <Link to='#' onClick={() => getToDeialsClick(truck.truck_orders_id, 'shipment')}>
                          Details
                        </Link>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <ImageUpload
                ref={imageUploadRef}
                attachable_type={selectedRowData?.trip_type == 'F' ? 'booking_schedule' : 'booking_schedule_date'}
                attachable_id={selectedRowData?.trip_type == 'F' ? dataToSend : selectedRowData.bookingtruck_date_id}
                attachments={selectedRowData.attachments}
                onDeleteSuccess={() => loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id)}
                attachment_no={selectedRowData.bookingtruck_no + ' / ' + selectedRowData?.departure_date}
              />
              <div>
                <ActivityComments
                  commentable_type={"booking_schedule_date"}
                  commentable_id={selectedRowData.bookingtruck_date_id}
                  allactivities={selectedRowData.activities}
                  onReloadDetails={() => loadDetails(selectedRowData.bookingtruck_id, selectedRowData.bookingtruck_date_id)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
});
export default ExportGrid;
// export {JGrid as default, exportToPDF}